import React, { useState, useEffect } from "react";
import { FaUser, FaUserTie } from "react-icons/fa";
import { useParams } from "react-router-dom";
import HomeCard from "../../../../components/HomeCard";
import MainView from "../../../../components/MainView";
import NavHistory from "../../../../components/NavHistory";
import api from "../../../../services";
import academyServices from "../../../../services/academy/academyServices";
import AcademyAccessCard from "./AcademyAccessCard";
import AcademyProfileCard from "./AcademyProfileCard";

import './styles.css';


export default function AdminAcademyPage(props) {
    const [academy, setAcademy] = useState({});
    const {id} = useParams();

    async function getAcademy() {
        try {
            const response = await academyServices.getAcademy(id);
            setAcademy(response.data);
        } catch(err) {
            alert("Erro ao pegar informações da academia.");
        }
    } 

    async function accessAcademyModule(academy) {
        try {
            localStorage.setItem("_academyInfos", JSON.stringify(academy));
            api.defaults.headers.academia = academy.id;
        } catch(err) {
            alert("Erro ao obter informações da academia.");
        }
    }

    useEffect(() => {
        getAcademy();
    }, []);

    useEffect(() => {
        if(Object.keys(academy).length > 0)
            accessAcademyModule(academy);
    },[academy])
    return (
        <MainView
        adminMenu
        currentPage="academies"
        >
            <NavHistory
            navPages={['Academias', (academy.nome ? academy.nome : "")]}
            />
            <div className="academy-profile-page-container">
                <AcademyProfileCard
                    academyInfos={academy}
                />

                <AcademyAccessCard
                academy={academy}
                />

                <HomeCard
                    title="Alunos"
                    to={`/admin/academias/${id}/alunos`}
                    icon={<FaUser/>}
                />

                <HomeCard
                    title="Professores"
                    to={`/admin/academias/${id}/professores`}
                    icon={<FaUserTie/>}
                />
            </div>
        </MainView>
    )
}